import { Popup } from "./Popup";
import { show } from "./rtBasePolyfills";
export class VideoPopup extends Popup {
    /** @param data */
    constructor(data) {
        var _a;
        super(data);
        this.videoContainerHTML =
            ((_a = document.querySelector(".rt-video-full-container")) === null || _a === void 0 ? void 0 : _a.outerHTML) || "";
    }
    display() {
        super.display();
        show(this.containerSelector, "flex");
        this.resizeContainer();
        this.play();
    }
    getDimensions() {
        const parentContainer = this.container.querySelector(".rt-pop-inner-content");
        if (!parentContainer) {
            throw new Error("Parent container not found");
        }
        const { clientWidth: width, clientHeight: height } = parentContainer;
        return [width, height];
    }
    getOuterDimensions() {
        const height = window.innerHeight * 0.8;
        const width = (height / 9) * 16;
        return [width, height + 36];
    }
    resizeContainer() {
        const innerContainer = this.container.querySelector(".rt-pop-announcement-content-full-width");
        const [oWidth, oHeight] = this.getOuterDimensions();
        innerContainer.style.width = String(oWidth) + "px";
        innerContainer.style.height = String(oHeight) + "px";
        const videoContainer = this.container.querySelector(".rt-video-full-container");
        const [width, height] = this.getDimensions();
        videoContainer.style.width = String(width) + "px";
        videoContainer.style.height = String(height) + "px";
    }
    hide() {
        super.hide();
        const parentContainer = this.container.querySelector(".rt-pop-inner-content");
        if (!parentContainer) {
            throw new Error("Parent container not found");
        }
        const iframe = parentContainer.querySelector("iframe");
        iframe === null || iframe === void 0 ? void 0 : iframe.remove();
        parentContainer.innerHTML = this.videoContainerHTML;
    }
    play() {
        const target = this.container.querySelector(".rt-video-facade-play");
        const { dataset, parentElement } = target;
        if (!parentElement) {
            throw new Error("Parent container not found");
        }
        const [width, height] = this.getDimensions();
        const { title } = dataset;
        const path = `https://www.youtube.com/embed/${dataset.video}?feature=oembed&autoplay=1`;
        parentElement.innerHTML = `<div class="rt-embed-responsive rt-embed-responsive-16by9"><iframe loading="lazy" title="${title}" src="${path}" allow="autoplay; clipboard-write; encrypted-media;" allowfullscreen="" name="fitvid0" height="${height}" width="${width}"></iframe></div>`;
    }
}
